import React, { Component } from 'react';
import classess from './OktaSignInWidget.scss';
import OktaCommonCss from './OktaCommonCss';
import OktaLoginScreenCss from './OktaLoginScreenCss';
import OktaSelectScreenCss from './OktaSelectScreenCss';
import OktaEmailScreenCss from './OktaEmailScreenCss';
import OktaPhoneScreenCss from './OktaPhoneScreenCss';
import { oktaTerminalChanges } from './OktaTerminalCss';
import LoadIndicator from '../../Common/CommonComponents/LoadingIndicator/loadingIndicator';
import { selectScreenHelper, reRenderWidget, reTryLogic } from './OktaSignInWidgetHelper';

class OktaSignInWidget extends Component {
  constructor(props) {
    super(props);
    this.widget = props.widgetInstance;
    this.state = {
      showloader: true,
      retry:0
    };
    this.loginObserver = null;
    this.phoneObserver = null;
    this.emailObserver = null;
    this.phoneVerifyObserver = null;
    this.loginErrorObserver = null;
    this.errorObserver = null;
    this.loaderObserver = null;
    this.fetchRetry = 0;
    const appRoute = app.appUtil.getAppRoutes().LOGIN;
    this.emailIcon = appRoute ? (app.appUtil.getDrupalURL() + appRoute['EMAIL_ICON']) : '';
    this.phoneIcon = appRoute ? (app.appUtil.getDrupalURL() + appRoute['PHONE_ICON']) : '';
    this.securityIcon = appRoute ? (app.appUtil.getDrupalURL() + appRoute['SECURITY_ICON']) : '';
    this.spinnerGif = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/loadinganimation.gif';
    this.unCheckedIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/UnChecked_Icon.jpg';
    this.CheckedIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Checked_Icon.jpg';
  }

  signInScreenHelper() {
    const submitButton = document.querySelector('#okta-sign-in.auth-container .button-primary');
    if (submitButton) {
      const loginObserverConfig = { attributes: true };
      submitButton.classList.add(classess.textSizeS);
      this.loginObserver = new MutationObserver(() => {
        if (submitButton.textContent === 'Sign in') {
          submitButton.textContent = 'LOG IN';
        }
      });
      this.loginObserver.observe(submitButton, loginObserverConfig);
    }
    const loginErrorDiv = document.querySelector('#okta-sign-in.auth-container .o-form-error-container');
    if (loginErrorDiv) {
      const loginErrorObserverConfig = { childList: true };
      this.loginErrorObserver = new MutationObserver(() => {
        const errorIcon = document.querySelector('#okta-sign-in .infobox-error >.icon');
        if (errorIcon) {
          errorIcon.classList.add(classess.errorBoxIcon);
        }
      });
      this.loginErrorObserver.observe(loginErrorDiv, loginErrorObserverConfig);
    }
  }

  backToSignIn() {
    const signEle = document.querySelector("#okta-sign-in a.link.js-cancel");
    if (signEle) {
      signEle.addEventListener('click', function (event) {
        try {
          app.appService.oktaWidget().then(function (widget) {
            widget.authClient.closeSession();
          }).catch(function (err) {
            // error loading widget
          });
        } catch (err) {
          // session not present or error in closing session
        }
      });
    }
  }

  observeForm(){
    this.observeFormErrors();
    this.observeOktaFormForLoader();
  }

  phoneScreenHelper(){
    const phoneObserverEle = document.querySelector('#okta-sign-in.auth-container .auth-content');
    if (phoneObserverEle) {
      const phoneObserverConfig = { childList: true, subtree: true };

      this.phoneObserver = new MutationObserver(() => {
        const sendPhoneContent = document.querySelector('#okta-sign-in.auth-container .okta-form-subtitle');
        if (sendPhoneContent) {
          sendPhoneContent.style.fontSize = '13px';
          sendPhoneContent.childNodes.forEach((node) => {
            if (node.nodeType === Node.TEXT_NODE && node.nodeValue.includes('Enter the code below to verify')) {
              node.nodeValue = '';
            }
          });
        }

      });
      this.phoneObserver.observe(phoneObserverEle, phoneObserverConfig);
    }
  }

  phoneVerifyScreenHelper(){
    const codeInput = document.querySelector('input[name="credentials.passcode"]');
    if (codeInput) {
      codeInput.style.boxShadow = '0px 2px 8px 2px #00000033 inset';
      codeInput.maxLength = 6;
    }
    const verifyPhoneButton = document.querySelector('#okta-sign-in.auth-container .o-form-error-container');
    if (verifyPhoneButton) {
      const phoneObserverConfig = { childList: true };

      this.phoneVerifyObserver = new MutationObserver(() => {
        const errorIcon = document.querySelector('#okta-sign-in .infobox-error > .icon');
        if (errorIcon) {
          errorIcon.classList.add(classess.errorIcon);
        }
      });
      this.phoneVerifyObserver.observe(verifyPhoneButton, phoneObserverConfig);
    }
  }

  emailVerifyScreenHelper(){
    const verifyEmailButton = document.querySelector('#okta-sign-in.auth-container .o-form-error-container');
    if (verifyEmailButton) {
      const emailObserverConfig = { childList: true };
      this.emailObserver = new MutationObserver(() => {
        const errorIcon = document.querySelector('#okta-sign-in .infobox-error > .icon');
        if (errorIcon) {
          errorIcon.classList.add(classess.errorIcon);
        }
      });
      this.emailObserver.observe(verifyEmailButton, emailObserverConfig);
    }
  }
  observeFormErrors = () => {
    if (this.errorObserver) {
      this.errorObserver.disconnect();
    }

    const errorContainer = document.querySelector('#okta-sign-in.auth-container .o-form-error-container');
    if (!errorContainer) return;
    const errorObserverConfig = { childList: true };
    this.errorObserver = new MutationObserver(() => {
      if (errorContainer.querySelector(".infobox-error") !== null) {
        this.closeLoaders();
      }
    });
    this.errorObserver.observe(errorContainer, errorObserverConfig);

  }

  observeOktaFormForLoader = () => {
    if (this.loaderObserver) {
      this.loaderObserver.disconnect();
    }

    const oktaForm = document.querySelector('#okta-sign-in form');
    if (!oktaForm) return;
    this.loaderObserver = new MutationObserver(() => {
      if (oktaForm.classList.contains('o-form-saving')) {
        const loader = document.querySelector('#loader');
        loader.style.display = 'flex';
      }
    });

    this.loaderObserver.observe(oktaForm, { attributes: true, attributeFilter: ['class'] });
  }
  
  closeLoaders = () => {
    const loader = document.querySelector('#loader');
    loader.style.display = 'none';
  }

  handleNonLoginScreen = () => {
    const modalCancel = document.getElementById('okta-widget-modal-cancel');
    if (modalCancel) {
      modalCancel.style.display = 'none';
    }
    if (this.loginObserver) {
      this.loginObserver.disconnect();
    }
    if (this.loginErrorObserver) {
      this.loginErrorObserver.disconnect();
    }
  }

  componentDidMount(){
    this.loadOktaWidget();
  }

  componentDidUpdate(prevProps, prevState){
    if(prevState.retry !== this.state.retry){
      this.loadOktaWidget();
    }
  }

  loadOktaWidget() {
    const { showloader } = this.state;
    const {popUpWidget} = this.props;

    try {
      this.widget.off();
      this.widget.remove();
    } catch (error) {
      // error in removing widget
    }

    try {
      this.widget.showSignInToGetTokens({
        el: `#okta-${popUpWidget ? 'modal' : 'inline'}-container`,
      }).then(this.props.onSuccess).catch((err) => {
        const { message } = err;
        if (["Failed to fetch", "Load failed"].includes(message)) {
          reRenderWidget.call(this, null, null, 250);
        }
      });
    } catch (error) {
      // widget failed to render
    }
    
    this.widget.on('afterError', (context, error) => {
      const { errorSummary } = error;
      this.closeLoaders();
      if (errorSummary === this.widget.options.i18n.en["error.unsupported.response"]) {
        reRenderWidget.call(this,context,error);
      }else {
        reTryLogic.call(this,context,error);
      }          
    });
    this.widget.on('afterRender', (context) => {

      
      if (showloader) {
        this.setState({
          showloader: false
        });
      }
      
      this.observeForm();

      const loader = document.querySelector('#loader');
      if(loader){
        loader.style.display = 'none';
      }

      OktaCommonCss(this.spinnerGif);

      // login screen observer

      if (context.formName !== 'identify' && context.formName !== 'terminal') {
        this.handleNonLoginScreen();
      }
      if (context.formName !== 'authenticator-verification-data') {
        if (this.phoneObserver) {
          this.phoneObserver.disconnect();
        }
        if (this.phoneVerifyObserver) {
          this.phoneVerifyObserver.disconnect();
        }
        if (this.emailObserver) {
          this.emailObserver.disconnect();
        }
      }

      if (context.formName === 'identify') {
        if (context.authenticatorKey === 'okta_password') {
          this.signInScreenHelper();
          //defaultEmailValue - this parameter is for retain the email values, its not a neccessary parameter
          OktaLoginScreenCss(this.unCheckedIcon, this.CheckedIcon, this.props.defaultEmailValue);
        }

      } else if (context.formName === 'select-authenticator-authenticate') {
        OktaSelectScreenCss(this.emailIcon, this.phoneIcon, this.securityIcon);
        selectScreenHelper(context);

      } else if (context.formName === 'authenticator-verification-data') {
        if (context.authenticatorKey === 'okta_email') {
          const loader = document.querySelector('#loader');
          loader.style.display = 'flex';
          const sendEmailButton = document.querySelector('#okta-sign-in.auth-container .button-primary');
          sendEmailButton.click();
        }
        if (context.authenticatorKey === 'phone_number') {
          this.phoneScreenHelper();
          OktaPhoneScreenCss(this.phoneIcon);
        }

      } else if (context.formName === 'challenge-authenticator') {
        if (context.authenticatorKey === 'okta_email') {
          OktaEmailScreenCss(this.emailIcon);
          this.emailVerifyScreenHelper();
        }
        if (context.authenticatorKey === 'phone_number') {
          OktaPhoneScreenCss(this.phoneIcon);
          this.phoneVerifyScreenHelper();
        }
        if (context.authenticatorKey === 'okta_password') {
          this.backToSignIn();
        }
      } else if (context.formName === "terminal") {
        oktaTerminalChanges.call(this);
      }

    }); 

  }

  componentWillUnmount() {
    if (this.widget) {
      this.widget.off();
      this.widget.remove();
    }
  }
  
  render() {
    const { showloader } = this.state;
    const {popUpWidget} = this.props;
    return (<div>
      {showloader && <LoadIndicator showLoading />}
      <div id={`okta-${popUpWidget ? 'modal' : 'inline'}-container`} />
    </div>);

  }

}
export default OktaSignInWidget;
